import { Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';

import { AccessDeniedComponent } from '@components/access-denied/access-denied.component';
import { SignInComponent } from '@components/sign-in/sign-in.component';
import { SignOutComponent } from '@components/sign-out/sign-out.component';
import { DashboardComponent } from 'src/app/features/dashboard/dashboard.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'sign-in',
    component: SignInComponent,
  },
  {
    path: 'sign-out',
    component: SignOutComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
